import { render } from "./aepiechart.vue?vue&type=template&id=4c732cb0&scoped=true"
import script from "./aepiechart.vue?vue&type=script&lang=js"
export * from "./aepiechart.vue?vue&type=script&lang=js"

import "./aepiechart.vue?vue&type=style&index=0&id=4c732cb0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c732cb0"]])

export default __exports__